import React from 'react';
import { DriversList } from '../DriversList';
import data from '../../cachedData/deviceDrivers.json';

export const DriversSection = () => <DriversList items={data} />;
